<script>
	import { onMount } from 'svelte';

	import PO from "./classes/ProductOrder.js";

	import Groups from './Groups.svelte';
	import Receipt from './Receipt.svelte';
	import ProductsOrders from './ProductsOrders.svelte';
	import ProductOrders from './ProductOrders.svelte';

	// Value objects
	let products = [];
	let supplements = [];

	// Business objects
	let productsOrders = [];
	let groups = [];

	// groups, products, cart, checkout
	let state = 'groups';
	function move_to_state(newState) {
		state = newState;
	}

	let stateData = {
		// Selected group
		groups: null,
		products: -1,
		checkout: -1
	}
	function setStateData(stat, value) {
		stateData[stat] = value;
	}

	onMount(async () => {
		const root = `PROXY_URL`;
		const g = await fetch(root + '/categories');

		let data;
		data = await g.json().then(response => {
			groups = response;
		});

		const res = await fetch(root + '/products');
		data = await res.json().then(response => {
			products = response;

			// Embed product within ProductOrders
			products.forEach(product => {
				let po = new PO.ProductOrders(product);
				productsOrders.push(po);
			});
			productsOrders = productsOrders;
		});

		const s = await fetch(root + '/modifiers');

		data = await s.json().then(response => {
			supplements = response;
			supplements.forEach(supplement => supplement.price = Number(supplement.price));
		});

	});

	// FIXME: bring narrative in line with UI
	// When a category is selected remember this category_id
	const changeGroup = (group) => {
		setStateData('groups', group);
		move_to_state('products');
	}

</script>

<button on:click="{()=> move_to_state('groups')}"
	class="groups {(state == 'groups') ? 'selected':''}"
>Groups</button>

<button on:click="{()=> move_to_state('products')}"
	class="products {(state == 'products') ? 'selected':''}"
>Products</button>

<button on:click="{()=> move_to_state('checkout')}"
	class="checkout {(state == 'checkout') ? 'selected':''}"
>Checkout</button>

{#if state == 'groups'}
<Groups groups={groups}
	on:changeGroup="{(ev) => changeGroup(ev.detail)}"
/>
{/if}

{#if state == 'products'}
<ProductsOrders
	productsOrders={productsOrders}
	group={stateData.groups}
	supplements={supplements}
/>
{/if}

{#if state == 'checkout'}
<Receipt {productsOrders} {supplements}/>
{/if}

<style>
	button.selected {
		font-weight: bolder;
	}
</style>